import { FunctionComponent } from 'react'

import { Icons, Illustrations } from 'atoms'
import { Box, Heading, Text, VStack } from 'native-base'

type TIdentityCard = {
  name?: string
  role?: string
}

const scale = 1.3

const cardWidth = 154 * scale

const cardHeight = 244 * scale

const s = (value: number) => Math.round(value * scale)

export const IdentityCard: FunctionComponent<TIdentityCard> = ({ name, role }) => {
  return (
    <VStack position="relative" w={`${cardWidth}px`} h={`${cardHeight}px`}>
      <Box position="absolute" top={0} left={0}>
        <Illustrations.IdentityCard width={cardWidth} height={cardHeight} />
      </Box>

      <VStack h="30%" />

      <VStack space={s(1)} my={s(4)} w="full" justifyContent="center" alignItems="center" px={s(2)}>
        <Heading
          fontSize={s(12)}
          bold
          color="gray.700"
          textTransform="uppercase"
          textAlign="center">
          {name ?? ''}
        </Heading>
        <Text fontSize={s(10)} fontWeight={400} color="gray.700" textAlign="center">
          {role ?? ''}
        </Text>
      </VStack>

      <VStack
        position="absolute"
        bottom={s(10)}
        left={0}
        space={s(2)}
        w="full"
        justifyContent="center"
        alignItems="center">
        <Box>
          <Icons.SantanderFinanciamentos />
        </Box>

        <VStack>
          <Text fontSize={s(6)} fontWeight={400} color="gray.700" textAlign="center">
            Santander Sociedade de Crédito,
          </Text>
          <Text fontSize={s(6)} fontWeight={400} color="gray.700" textAlign="center">
            Financiamento e Investimento S.A.
          </Text>
        </VStack>
      </VStack>
    </VStack>
  )
}
